import { getItemsFromApiResponse } from '../../../utils/api'
import { InputAsyncSelect, InputSelectControl } from '../../Select'
import { getLabels } from '../Label.api'
import { getAvailableLabels, toLabelSelectItems } from '../Label.utils'
import { LabelSelectDropdownListItemContentInfoText } from '../LabelSelectDropdownListItemContentInfoText'

function LabelSelect({
  Control = InputSelectControl,
  entity,
  getData,
  getDataItems = getItemsFromApiResponse,
  listProps,
  toPreparedItems = toLabelSelectItems,
  ...restProps
}) {
  const labelGetData =
    getData ?? (entity ? getAvailableLabels(entity) : getLabels)

  return (
    <InputAsyncSelect
      {...restProps}
      Control={Control}
      getData={labelGetData}
      getDataItems={getDataItems}
      listProps={{
        ...listProps,
        itemProps: {
          contentProps: {
            infoProps: {
              ContentText: LabelSelectDropdownListItemContentInfoText,
            },
          },
        },
      }}
      toPreparedItems={toPreparedItems}
    />
  )
}

export default LabelSelect
